<template>
    <b-navbar toggleable="md" type="dark" variant="dark">
    <div class="container">
      <b-navbar-toggle target="nav_collapse" v-if="isLoggedIn"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse" v-if="isLoggedIn">
        <b-navbar-nav class="d-flex w-100">
          <li class="nav-item"><router-link class="nav-link text-uppercase font-weight-bold" exact-active-class="active" :to="{ name: 'home'}" title="Home"><i class="fa fa-home fa-fw" aria-hidden="true"></i> Inicio</router-link></li>
          <li class="nav-item"><router-link class="nav-link text-uppercase font-weight-bold" exact-active-class="active" :to="{ name: 'usuarios'}" title="Usuarios"><i class="fa fa-users fa-fw" aria-hidden="true"></i> Usuarios</router-link></li>
          <li class="nav-item"><router-link class="nav-link text-uppercase font-weight-bold" exact-active-class="active" :to="{ name: 'calendario'}" title="Calendario"><i class="fa fa-calendar-alt fa-fw" aria-hidden="true"></i> Calendario</router-link></li>
          <li class="nav-item"><router-link class="nav-link text-uppercase font-weight-bold" exact-active-class="active" :to="{ name: 'documentos'}" title="Documentos"><i class="fa fa-file-alt fa-fw" aria-hidden="true"></i> Documentos</router-link></li>
          <li class="nav-item"><router-link class="nav-link text-uppercase font-weight-bold" exact-active-class="active" :to="{ name: 'notificaciones'}" title="Notificaciones"><i class="fa fa-bell fa-fw" aria-hidden="true"></i> Notificaciones</router-link></li>
          <li class="nav-item"><router-link class="nav-link text-uppercase font-weight-bold" exact-active-class="active" :to="{ name: 'newsletter'}" title="Newsletter"><i class="fa fa-newspaper fa-fw" aria-hidden="true"></i> Newsletter</router-link></li>
          <li class="nav-item ml-auto"><a class="nav-link text-light" href="#" v-if="isLoggedIn">{{ currentUser.email }}</a></li>
          <li class="nav-item"><a class="nav-link text-light text-uppercase font-weight-bold" href="#" v-if="isLoggedIn" :to="'login'" @click="logout" title="Cerrar sesión"><i class="fa fa-power-off fa-fw" aria-hidden="true"></i> Salir</a></li>
        </b-navbar-nav>
      </b-collapse>
      <span class="text-light" v-if="!isLoggedIn"><i class="fa fa-lock fa-fw" aria-hidden="true"></i> Acceder</span>
    </div>
    </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import {APIENDPOINT, CLIENTID, CLIENTSECRET} from '@/backend'

var qs = require('qs')

export default {
  data () {
    return {
      remainingToken: 0
    }
  },

  beforeMount () {
    this.checkToken()
    clearInterval(this.interval)
  },

  mounted () {
    this.interval = setInterval(this.checkToken, 10000)
  },

  destroyed () {
    clearInterval(this.interval)
  },

  methods: {
    logout: function () {
      delete localStorage.token
      this.$router.push({name: 'login'})
      this.$store.dispatch('logout')
    },

    checkToken () {
      if (localStorage.getItem('token') !== null) {
        this.remainingToken = this.currentUser.expiration - this.$moment().unix()
        // console.log('sesión restante: ' + this.remainingToken)
        if (this.remainingToken < 60 && this.remainingToken > 0) {
          /* sesión a punto de expirar (60 segundos) */
          this.refreshTokenDialog()
        }
        if (this.remainingToken <= 0) {
          /* sesión expirada */
          this.logout()
        }
      } else {
        this.logout()
      }
    },

    refreshTokenDialog () {
      clearInterval(this.interval)
      this.$alert('Su sesión está a punto de expirar', 'Aviso', {
        confirmButtonText: 'Renovar',
        callback: action => {
          this.refreshTokenCall()
        }
      })
    },

    refreshTokenCall () {
      axios({
        method: 'post',
        baseURL: APIENDPOINT,
        url: '/api/admin/login',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        auth: {
          username: CLIENTID,
          password: CLIENTSECRET
        },
        data: qs.stringify({
          'grant_type': 'refresh_token',
          'refresh_token': JSON.parse(localStorage.getItem('token')).refresh_token
        })
      })
      .then(response => this.refreshSuccessful(response))
      .catch(() => this.refreshFailed())
    },

    refreshSuccessful (response) {
      console.log('refreshSuccessful')
      console.log(response)
      if (!response.data.access_token) {
        this.refreshFailed()
        return
      }
      this.loadingLogin = false
      // localStorage.token = JSON.stringify(response.data)
      localStorage.setItem('token', JSON.stringify(response.data))
      this.$store.dispatch('token')
      this.$store.dispatch('login')
      this.$notify({
        type: 'success',
        message: 'Sesión renovada'
      })
      this.interval = setInterval(this.checkToken, 10000)
    },

    refreshFailed (e) {
      this.message = 'Acceso denegado'
      this.$message({
        showClose: true,
        message: this.message,
        type: 'warning'
      })
      this.$store.dispatch('logout')
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      currentToken: 'currentToken'
    }),

    isLoggedIn () {
      return this.$store.getters.currentUser
    }
  }
}
</script>

<style lang="scss">
.navbar {
  min-height: 54px;
  font-family: 'Roboto Condensed', sans-serif;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
}
</style>
